import React from "react";

import { getLinkHref, getManufacturerNames } from "../pages/linksUtils";

export default function LinksRow({ linksArray }) {
  const items = Array.isArray(linksArray) ? linksArray : linksArray?.data || [];

  if (!items.length) {
    return null;
  }

  return (
    <ul className="retro-links-list">
      {items.map((item) => {
        const manufacturers = getManufacturerNames(item);
        const href = getLinkHref(item?.Link);

        return (
          <li className="retro-links-card" key={item?.id || item?.Link}>
            <div className="retro-links-card-main">
              <span className="retro-link-kicker">Źródło</span>
              <h3>{item?.Name || 'Bez nazwy'}</h3>
              <p>{item?.Description || 'Opis czeka na uzupełnienie.'}</p>
              <div className="retro-links-tags">
                {manufacturers.map((manufacturer) => (
                  <span key={manufacturer}>{manufacturer}</span>
                ))}
              </div>
            </div>

            <a className="retro-link-url" href={href} target="_blank" rel="noopener noreferrer">
              <span>Adres</span>
              <strong>{item?.Link || href}</strong>
              <i className="feather-external-link" aria-hidden="true"></i>
            </a>
          </li>
        );
      })}
    </ul>
  );
}
